import { render, staticRenderFns } from "./memberCancellation.vue?vue&type=template&id=5b1850a8&scoped=true"
import script from "./memberCancellation.vue?vue&type=script&lang=js"
export * from "./memberCancellation.vue?vue&type=script&lang=js"
import style0 from "./memberCancellation.vue?vue&type=style&index=0&id=5b1850a8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1850a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1850a8')) {
      api.createRecord('5b1850a8', component.options)
    } else {
      api.reload('5b1850a8', component.options)
    }
    module.hot.accept("./memberCancellation.vue?vue&type=template&id=5b1850a8&scoped=true", function () {
      api.rerender('5b1850a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/memberCancellation.vue"
export default component.exports